import React from 'react'
import { Link } from 'react-router-dom'
import './Home.css'

function Home() {
  return (
    <div className='text-center cover-image-container'>
      <img
        src={require('../Media/mountains_1.jpg')}
        id='cover-image'
        className='img-fluid'
        alt='mountains'
      />
      <div className='cover-image-text'>
        <h2>Jeff Heller</h2>
        <hr></hr>
        <h5>
          <i className='fas fa-bars'></i>
        </h5>
        <h5>
          <Link to='/experience/dap'>Experience</Link>
        </h5>
        <h5>
          <Link to='/contact'>Contact</Link>
        </h5>
      </div>
    </div>
  )
}

export default Home
